export const tssHydrate = 'tss-hydrate'
